import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'style/layout/Table.css';

const BasicTable = ({
  columns,
  data,
  page,
  sizePerPage,
  totalSize,
  handleTableChange,
  setSelectedRow,
  keyField,
}: {
  columns: any;
  data: any;
  page: any;
  sizePerPage: any;
  totalSize: any;
  handleTableChange: any;
  setSelectedRow: any;
  keyField: any;
}): JSX.Element | null => {
  const rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      if (e.target.type === 'checkbox') return;
      let stopRowClick = false;
      if (e.target.tagName.toLowerCase() === 'td') {
        const inputs: any = Array.from(e.target.getElementsByTagName('input'));
        const cboxes: any = inputs.filter(
          (input: any) => input.type === 'checkbox'
        );
        stopRowClick = cboxes.length > 0 && cboxes.length === inputs.length;
      }
      if (!stopRowClick) {
        setSelectedRow(rowIndex);
      }
    },
  };

  const availableSizes = [10, 25, 50, 100, 200, 250];

  const sizePerPageList = availableSizes.map((size) => ({
    text: size.toString(),
    value: size,
  }));

  return (
    <div className="basic-table">
      <BootstrapTable
        classes="basic-table-width"
        keyField={keyField}
        headerWrapperClasses="table-header"
        bodyClasses="table-body"
        rowClasses="row-body"
        bordered={false}
        columns={columns}
        data={data || []}
        remote
        pagination={paginationFactory({
          page,
          sizePerPage,
          sizePerPageList,
          totalSize,
        })}
        onTableChange={handleTableChange}
        rowEvents={rowEvents}
      />
    </div>
  );
};

export default BasicTable;
